import { useDispatch } from "react-redux";
import { AuthsDispatch } from "./AuthsStore";

export const useAuthsDispatch = useDispatch.withTypes<AuthsDispatch>();
